module.exports = __webpack_public_path__ + "static/media/plus.16545d16.svg";